export const resolveErrorContent = (rawContent: string, errorMessages?: Record<string, string>): string => {
    if (errorMessages && Object.prototype.hasOwnProperty.call(errorMessages, rawContent)) {
        return errorMessages[rawContent] ?? rawContent;
    }
    return rawContent;
};
